import styled from 'styled-components';
import {Heading1} from '../../../utils/styles/typography';
import darkTheme from '../../../utils/styles/darkTheme';

export default styled.div`
  padding-bottom: 56.25%;
  width: 100%;
  position: relative;
  .player-cover-image,
  .spinner-wrapper {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }
  .player-cover-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  &.pausedContainer {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }
  &.loadingCover {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 2;
    padding-bottom: 0;
    background: #000;
  }
  .register-btn {
    background-color: ${darkTheme.surface};
    border-color: ${darkTheme.surface};
    font-weight: 700;
    &:hover {
      background-color: ${darkTheme.blue};
      border-color: ${darkTheme.blue};
      box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.14), 0px 3px 1px rgba(0, 0, 0, 0.12), 0px 1px 5px rgba(0, 0, 0, 0.2);
    }
  }
  .watch-btn {
    background-color: transparent;
    border: 1px solid #fff;
    font-weight: 700;
    border-radius: 5px;

    &:active,
    &:focus,
    &:focus-visible,
    &:focus-within {
      background: transparent !important;
    }
    &:hover {
      border: none;
      border-left: 1px solid #0dfff3;
      border-right: 1px solid #008aff;
      background-image: linear-gradient(90deg, #0dfff3, #008aff), linear-gradient(90deg, #0dfff3, #008aff);
      background-size: 100% 1px;
      background-position: 0 0, 0 100%;
      background-repeat: no-repeat;
    }
    .watch-icon {
      height: 12px;
      font-style: normal;
      font-weight: 900;
      font-size: 12px;
      line-height: 12px;
      align-items: center;
      text-align: center;
    }
  }
  .lock-wrapper {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background: linear-gradient(90deg, rgba(0, 138, 255, 0.9) 0%, rgba(144, 67, 255, 0.9) 100%);
    filter: drop-shadow(0px 2px 2px rgba(0, 0, 0, 0.14)) drop-shadow(0px 3px 1px rgba(0, 0, 0, 0.12))
      drop-shadow(0px 1px 5px rgba(0, 0, 0, 0.2));
    box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.14), 0px 3px 1px rgba(0, 0, 0, 0.12), 0px 1px 5px rgba(0, 0, 0, 0.2);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    // &::after {
    //   position: absolute;
    //   content: '';
    //   height: 100%;
    //   width: 100%;
    //   background-color: #000;
    //   opacity: 0.4;
    //   z-index: 0;
    // }
    .lock-link {
      position: relative;
      z-index: 1;
      height: 8.5rem;
      width: 8.5rem;
      border: 3px solid #fff;
      border-radius: 8.5rem;
      background-color: #a7a7a791;
      display: flex;
      align-items: center;
      justify-content: center;
      .lock-icon {
        color: #fff;
        font-size: 3.5rem;
      }
    }
  }

  /* ─────────────────────────────────────────────
     Pre-test overlay — centered, no stretch
     ───────────────────────────────────────────── */
  .pretest-lock-wrapper {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background: linear-gradient(135deg, rgba(0, 100, 220, 0.96) 0%, rgba(120, 40, 230, 0.96) 100%);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    overflow: hidden;
  }

  /* wrapper — sizes to content, scrolls only if content exceeds player */
  .pre-test-form {
    width: 100%;
    max-height: calc(100% - clamp(10px, 2vw, 20px));
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    overflow-x: hidden;
    padding: clamp(8px, 2vw, 16px) clamp(12px, 3vw, 24px);
    gap: clamp(6px, 1.2vw, 10px);
    box-sizing: border-box;
  }

  .pre-test-form::-webkit-scrollbar {
    width: 5px;
  }
  .pre-test-form::-webkit-scrollbar-track {
    background: rgba(255, 255, 255, 0.1);
    border-radius: 4px;
  }
  .pre-test-form::-webkit-scrollbar-thumb {
    background: rgba(255, 255, 255, 0.7);
    border-radius: 4px;
  }
  .pre-test-form::-webkit-scrollbar-thumb:hover {
    background: rgba(255, 255, 255, 0.95);
  }

  .pre-test-question {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: clamp(6px, 1.2vw, 10px);
  }

  /* "Question X of Y" counter */
  .pre-test-question > h1 {
    margin: 0;
    font-size: clamp(0.55rem, 1.3vw, 0.8rem);
    font-weight: 600;
    color: rgba(255, 255, 255, 0.8);
    text-align: center;
    letter-spacing: 0.05em;
    text-transform: uppercase;
  }

  .pre-test-question-block {
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: clamp(6px, 1.2vw, 10px);
  }

  /* ── 2-column grid — direct parent of labels ── */
  .form-check-container {
    width: 100%;
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: clamp(6px, 1.2vw, 10px);
  }

  /* shrink Bootstrap margin on the Next/Submit button inside the overlay */
  .pretest-lock-wrapper .mt-3 {
    margin-top: clamp(2px, 0.5vw, 8px) !important;
  }

  /* reset generic label/input rules inside the overlay */
  .pretest-lock-wrapper label {
    white-space: normal !important;
    display: flex !important;
    margin-bottom: 0 !important;
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }

  .pretest-lock-wrapper input {
    transform: none !important;
    margin: 0 !important;
  }

  &.fullscreen-div {
    position: fixed;
    z-index: 10000;
    left: 0;
    height: 100%;
  }
  /* .question {
    font-family: Arial, Helvetica, sans-serif;
    font-size: 2.25em;
    font-weight: bolder;
    text-align: center;
  }
  label {
    white-space: nowrap;
  }

  input {
    transform: scale(1.5);
    margin-right: 10px;
  } */
  .question {
    font-family: Arial, Helvetica, sans-serif;
    font-size: 2.25em;
    font-weight: bolder;
    text-align: center;
    margin: 0 auto;
    max-width: 70%;
  }

  label {
    white-space: nowrap;
    display: block;
    margin-bottom: 1em;
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }

  input {
    transform: scale(1.5);
    margin-right: 10px;
    margin-left: 10px;
  }

  @media only screen and (max-width: 375px) {
    .question {
      font-size: 0.7em;
    }
    input {
      transform: scale(0.7);
      margin-right: 1px;
      margin-left: 5px;
    }
  }

  @media only screen and (min-width: 376px) and (max-width: 580px) {
    .question {
      font-size: 0.8em;
    }
    input {
      transform: scale(0.9);
      margin-right: 10px;
    }
  }

  @media only screen and (min-width: 581px) and (max-width: 790px) {
    .question {
      font-size: 1.3em;
    }
    input {
      transform: scale(1);
      margin-right: 5px;
    }
  }

  @media only screen and (min-width: 791px) and (max-width: 1023px) {
    .question {
      font-size: 1.2em;
    }
  }
`;

export const Time = styled(Heading1)`
  line-height: 40px;
  text-align: center;
  color: #ffffff;
`;

export const Subtitle = styled.div`
  font-size: 18px;
  line-height: 38.5px;
  font-weight: 400;
`;

export const Videoplayer = styled.div`
  position: relative;
  .on-fullscreen {
    display: none;
  }

  .video-screen {
    position: relative;
    min-height: 0;
  }

  .player-mount {
    position: relative;
    width: 100%;
    padding-bottom: 56.25%;
    background-color: #000;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    overflow: hidden;
  }

  .player-mount-node {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }

  .player-mount video {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 1;
    transition: opacity 0.15s ease-in;
  }

  .player-mount-loading .spinner-wrapper {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 2;
    background: rgba(0, 0, 0, 0.12);
  }

  .player-mount-ready {
    background-image: none !important;
  }

  .player-mount-loading video {
    opacity: 0;
    pointer-events: none;
  }
`;

export const Skip = styled.button`
  background: rgba(0, 0, 0, 0.4);
  color: #fff;
  border: none;
  padding: 10px 25px;
  line-height: 14px;
  font-size: 14px;

  @media only screen and (min-width: 0px) and (max-width: 375px) {
    padding: 4px 6px;
    line-height: 6px;
    font-size: 10px;
  }

  @media only screen and (min-width: 376px) and (max-width: 479px) {
    padding: 6px 8px;
    line-height: 7px;
    font-size: 10px;
  }
`;

export const Bumper = styled.div`
  img {
    width: 100%;
  }
  .surveyImage {
    height: 60vh;
  }
`;

export const Sponsored = styled.div`
  position: absolute;
  bottom: 40px;
  height: 31px;
  display: flex;
  justify-content: right;
  width: 100%;
  padding-left: 10px;

  small {
    margin: auto 0;
    margin-right: auto;
  }
`;
export const SurveyForm = styled.form`
  color: #fff;

  max-width: 100%;
  max-height: 100%;
  margin-left: auto;
  margin-right: auto;

  label:hover {
    background: rgba(0, 0, 0, 0.2);
    cursor: pointer;
  }
`;

export const PreTestForm = styled.form`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: clamp(6px, 1.2vw, 10px);
  color: #fff;
`;

export const PreTestQuestionBlock = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: clamp(6px, 1.2vw, 10px);
  text-align: center;

  /* Question text */
  > h1 {
    margin: 0;
    font-size: clamp(0.78rem, 2vw, 1.2rem);
    font-weight: 700;
    line-height: 1.35;
    word-break: break-word;
    white-space: normal;
    color: #fff;
  }

  /* Next / Submit button row */
  > div:last-of-type {
    margin-top: clamp(2px, 0.5vw, 4px);
  }

  p {
    margin: 0;
    font-size: clamp(0.55rem, 1.1vw, 0.8rem);
    color: rgba(255, 255, 255, 0.85);
  }
`;

/* Pass-through wrapper — grid lives on .form-check-container */
export const PreTestFormCheckContainer = styled.div`
  width: 100%;
`;

export const PreTestStyledLabel = styled.label`
  display: flex !important;
  align-items: center;
  justify-content: center;
  padding: clamp(5px, 1.3vw, 11px) clamp(4px, 1vw, 8px);
  border-radius: 8px;
  background-color: ${({selected}) => (selected ? 'rgba(0, 100, 255, 0.75)' : 'rgba(255, 255, 255, 0.12)')};
  border: 1.5px solid ${({selected}) => (selected ? 'rgba(100, 170, 255, 0.9)' : 'rgba(255, 255, 255, 0.25)')};
  color: #fff !important;
  cursor: pointer;
  transition: background-color 0.2s ease, border-color 0.2s ease, transform 0.1s ease;
  font-size: clamp(0.56rem, 1.35vw, 0.88rem);
  line-height: 1.3;
  white-space: normal !important;
  word-break: break-word;
  text-align: center;
  min-height: clamp(30px, 5.5vw, 46px);
  box-shadow: ${({selected}) => (selected ? '0 0 0 2px rgba(100, 170, 255, 0.4)' : '0 1px 3px rgba(0,0,0,0.2)')};

  &:hover {
    background-color: ${({selected}) => (selected ? 'rgba(0, 100, 255, 0.85)' : 'rgba(255, 255, 255, 0.22)')};
    border-color: rgba(255, 255, 255, 0.55);
    transform: translateY(-1px);
  }

  &:active {
    transform: translateY(0);
  }

  input {
    display: none;
  }
`;

export const SubmitButton = styled.button`
  background: rgba(0, 0, 0, 0.4);
  color: #fff;
  padding: 10px 15px;
  border: none;
  border-radius: 19px;
  cursor: pointer;
  display: block;
  margin: auto;

  &:hover {
    background-color: #2d80b9;
  }

  @media only screen and (min-width: 376px) and (max-width: 580px) {
    padding: 5px 7px;
    font-size: x-small;
    margin-top: 1.5em;
  }

  @media only screen and (min-width: 0px) and (max-width: 375px) {
    padding: 4px 6px;
    font-size: xx-small;
    margin-top: 1.5em;
  }
`;
